import { Button } from '../../../../components/ui/button';
import { deleteCommentConfirmCopy } from '../../../../lib/inboxRowActions';

// The confirm before a club deletes a member's comment. Deleting is PERMANENT on the
// platform and public, so this NAMES the author and QUOTES the comment, in the same
// inline alertdialog shape as the composer's publish confirm (a portaled dialog would
// take the staff tokens inside the portal). The wording is `deleteCommentConfirmCopy`,
// asserted without jsdom.

export type DeleteTarget = { threadId: string; messageId: string; authorName: string; text: string };

export function DeleteCommentConfirm({
  target,
  pending,
  onConfirm,
  onCancel,
}: {
  target: DeleteTarget;
  pending: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  const copy = deleteCommentConfirmCopy(target.authorName, target.text);
  return (
    <div className="rounded-md border-2 border-tone-warning-foreground p-3" role="alertdialog" aria-label="Confirm delete" data-testid="confirm-delete">
      <p className="text-sm font-medium text-foreground">{copy.title}</p>
      <blockquote className="mt-2 whitespace-pre-wrap rounded bg-muted px-3 py-2 text-sm text-foreground" data-testid="confirm-delete-quote">
        {copy.quote}
      </blockquote>
      <p className="mt-2 text-sm text-muted-foreground">{copy.warning}</p>
      <div className="mt-3 flex gap-2">
        <Button variant="destructive" disabled={pending} onClick={onConfirm}>
          {pending ? 'Deleting…' : 'Yes, delete it'}
        </Button>
        <Button variant="outline" disabled={pending} onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </div>
  );
}
